<div class="page-container faq-container">
  <app-section sectionTitle="ALBION FREE MARKET TERMS OF SERVICE">
    <div class="faq-list">
      <app-subsection subSectionTitle="Subscription and Services">
        <p>Subscriptions grant access to premium features and contribute to the maintenance and development of Albion Free Market.</p>
        <p>All subscriptions are billed on a recurring basis. By confirming your subscription, you authorize Albion Free Market to process recurring payments.</p>
        <p>You may cancel your subscription at any time through the <a routerLink="/manage-subscription">Manage Subscriptions</a> page.</p>
      </app-subsection>

      <app-subsection subSectionTitle="Refund Policy">
        <p>
          Subscriptions are non-refundable. An exception will be considered in cases of documented technical issues that prevent you from accessing our services. To be eligible, you must have actively sought resolution by contacting our
          support team through the official channels provided.
        </p>
      </app-subsection>

      <app-subsection subSectionTitle="Compliance with Sandbox Interactive (SBI) Policies">
        <p>
          Albion Free Market is a tool designed to be used in accordance with the terms of service of Albion Online, as set by Sandbox Interactive (SBI). Our service utilizes passive monitoring of network traffic, a practice which SBI has
          publicly stated it does not consider an offense.
        </p>
        <ul>
          <li>
            SBI allows passive monitoring of network traffic for analysis:
            <blockquote>
              "As some of you have already pointed out, using WireShark or silimar tools to analyze network traffic is undetectable from our end and we therefore do not consider it an offense. The network packets do not contain any secret
              information, it is basically all stuff you can see on screen in the game in some form. If you wanna build a tool based on that - fine." (<a
                href="https://forum.albiononline.com/index.php/Thread/51604-Is-it-allowed-to-scan-your-internet-trafic-and-pick-up-logs/?postID=512670#post512670"
                target="_blank"
                >source</a
              >)
            </blockquote>
          </li>
        </ul>
        <p>
          While we strive to ensure compliance, SBI's policies may change, and the interpretation of their rules is at their sole discretion. We do not have control over SBI's decisions, and they do not officially endorse any third-party
          applications. You are solely responsible for understanding and complying with all applicable SBI policies, and for any consequences that may affect your game account. We strongly recommend that if you have any doubts, you contact
          SBI directly to make an informed decision.
        </p>
      </app-subsection>

      <app-subsection subSectionTitle="Your Responsibility and Our Disclaimers">
        <p>Our services are provided on an "as is" basis. While we aim for a reliable and secure experience, we can't guarantee our services will be uninterrupted or error-free.</p>
        <p>By using Albion Free Market, you agree to be responsible for your actions and to comply with these terms. This includes any consequences that may arise from your use of the service, such as impacts on your game account.</p>
        <p>Using our services for illegal activities or actions that could harm the platform or its users is prohibited. Violating these terms or SBI's Terms and Conditions may result in a ban from our services.</p>
      </app-subsection>

      <app-subsection subSectionTitle="Account Sharing">
        <p>Subscriber accounts are intended for individual use and are non-transferable. Sharing your account with others is strictly prohibited.</p>
      </app-subsection>

      <app-subsection subSectionTitle="Buyer Support">
        <p>For assistance, please contact our support team:</p>
        <ul>
          <li><strong>Email: </strong> <a href="mailto:albionfreemarket@gmail.com">albionfreemarket&#64;gmail.com</a></li>
          <li><strong>Discord:</strong> For faster support and community interaction, we recommend joining our <a href="https://discord.gg/BPmDE3zznH" target="_blank">Discord server</a>.</li>
        </ul>
      </app-subsection>

      <app-subsection subSectionTitle="Contact">
        <p>For general inquiries, please visit the <a routerLink="/feedback">Feedback Page</a>.</p>
        <p>We usually respond within 24 hours.</p>
      </app-subsection>

      <app-subsection subSectionTitle="Changes to Terms">
        <p>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of any changes by posting the new Terms on this page. Your continued use of the service after any such changes
          constitutes your acceptance of the new Terms.
        </p>
      </app-subsection>
    </div>
  </app-section>
</div>
